import { CONNECT_ROLES_API_ENDPOINT } from "../config/servicesEndpoints";
import { RoleGroupInterface } from "../features/Users/types";
import http from "./http";

export function fetchConnectRoles(): Promise<RoleGroupInterface[]> {
  return http.get(CONNECT_ROLES_API_ENDPOINT).then((response) => response.data);
}
